import { normaliseSeed } from './swiss';

/**
 * The alphabet groups for partner-assisted scanning (1.15), and for the printed card (1.16).
 *
 * **One source for both**, deliberately. The printed card is what gets used on the day the iPad is
 * flat or the person cannot manage the screen at all — and a card whose groups disagree with the app
 * would be worse than no card, because the caregiver would have learned the wrong sequence.
 *
 * Group design: six groups of five, ordered so the most frequent German initial letters come first.
 * A caregiver asks "A bis E?", the person answers yes or no, and a wrong guess costs one question.
 * Five per group keeps the spoken group short enough to hold in your head while listening for an
 * answer.
 *
 * The umlauts sit at the end rather than beside their base letters: a caregiver reading aloud will
 * naturally say "A B C D E", and inserting Ä after A makes the group hard to say and hard to hear.
 */

export interface AlphabetGroup {
  id: string;
  /** What the caregiver says aloud. */
  label: string;
  letters: string[];
}

const GROUPS_RAW: AlphabetGroup[] = [
  { id: 'g1', label: 'E, N, I, S, R', letters: ['E', 'N', 'I', 'S', 'R'] },
  { id: 'g2', label: 'A, T, D, H, U', letters: ['A', 'T', 'D', 'H', 'U'] },
  { id: 'g3', label: 'L, C, G, M, O', letters: ['L', 'C', 'G', 'M', 'O'] },
  { id: 'g4', label: 'B, W, F, K, Z', letters: ['B', 'W', 'F', 'K', 'Z'] },
  { id: 'g5', label: 'P, V, J, Y, X', letters: ['P', 'V', 'J', 'Y', 'X'] },
  { id: 'g6', label: 'Q, Ä, Ö, Ü, Leerzeichen', letters: ['Q', 'Ä', 'Ö', 'Ü', ' '] },
];

export const ALPHABET_GROUPS: readonly AlphabetGroup[] = normaliseSeed(GROUPS_RAW);

/** Every character the partner-assisted mode can produce. */
export const ALPHABET_LETTERS: readonly string[] = ALPHABET_GROUPS.flatMap((g) => g.letters);
